module.exports = __webpack_public_path__ + "static/necromite_of_myrkul-037badbbb9689f23486366ca53d962c4.jpeg";